import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConflict = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 30,
	viewBox: "0 0 36 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.056 1.07032C16.9591 -0.356781 19.0409 -0.356776 19.944 1.07033L35.6397 25.8713C36.6091 27.4031 35.5085 29.4022 33.6956 29.4022L2.30436 29.4022C0.491532 29.4022 -0.609121 27.4031 0.360324 25.8713L16.056 1.07032Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M33.6956 27.1016L18 2.30064L2.30436 27.1016L33.6956 27.1016ZM19.944 1.07033C19.0409 -0.356776 16.9591 -0.356781 16.056 1.07032L0.360324 25.8713C-0.609121 27.4031 0.491532 29.4022 2.30436 29.4022L33.6956 29.4022C35.5085 29.4022 36.6091 27.4031 35.6397 25.8713L19.944 1.07033Z",
			fill: "#FF0000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3582 8.81152H16.7432L13.5713 17.0341H16.7432L14.1777 25.6062L20.3582 15.4036H17.2796L20.3582 8.81152Z",
			fill: "#FF0000"
		})
	]
});
export default SvgConflict;
